import { render } from "./Header404page.vue?vue&type=template&id=f7e91c64"
import script from "./Header404page.vue?vue&type=script&lang=js"
export * from "./Header404page.vue?vue&type=script&lang=js"

import "./Header404page.vue?vue&type=style&index=0&id=f7e91c64&lang=css"

import exportComponent from "/home/runner/work/policies/policies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__